import PowerBackup from 'elem/compPage/PowerBackup';
import dynamic from 'next/dynamic';
import { GetServerSidePropsContext } from 'next';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/power-backup';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

// CSR NA版本
export default function PowerBackupPage({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('powerbackup');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PowerBackup />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!['us', 'ca', 'au', 'kr'].includes(locale as string)) {
        return redirectTo404();
    }

    // us ca 需要重定向 2025/06/16 15:00:00
    if (['us', 'ca'].includes(locale as string)) {
        let data = null;
        try {
            data = require(`elem/compPage/battery-backup-for-home/config/times/${locale}.js`);
        } catch (err) {
            data = require(`elem/compPage/battery-backup-for-home/config/times/us.js`);
        }
        const timeLine = data.timeLine || null; // 代码保存的时间线
        let systemTime = new Date().getTime(); // 系统时间
        if (_timer) {
            // 读取url上的时间进行测试
            const _timer2 = `${_timer} GMT+8`;
            systemTime = new Date(_timer2).getTime();
        }

        // 保留参数
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(query)) {
            if (Array.isArray(value)) {
                value.forEach((v) => params.append(key, v));
            } else if (value !== undefined) {
                params.append(key, value as string);
            }
        }
        const queryString = params.toString();
        const destination = `battery-backup-for-home${queryString ? `?${queryString}` : ''}`;
        // 需要重定向
        if (systemTime >= timeLine?.statusA?.start) {
            return {
                redirect: {
                    destination,
                    permanent: true,
                },
            };
        }
    }

    return {
        props: {
            debug: debug || '',
        },
    };
}
